import React from "react";
import "./index.css";
// import { GiRaining } from "react-icons/gi";
import moment from "moment";
import PropTypes from "prop-types";

const WeatherReport = (props) => {
  console.log(props, "props");
  const forecastData =
    props.areaData && props.areaData.length > 0
      ? props.areaData.map((data) => {
          return {
            sun: data.sun ? data.sun : "",
            H: data.H ? data.H : "",
            L: data.L ? data.L : "",
            area: props.areaName,
            date: moment().format("dddd Do MMMM"),
            // forecast: [
            //   { day: "Fri", high: 30, low: 27 },
            //   { day: "Sat", high: 29, low: 27 },
            //   { day: "Sun", high: 30, low: 27 },
            //   { day: "Mon", high: 30, low: 27 },
            //   { day: "Tue", high: 30, low: 27 },
            //   { day: "Wed", high: 29, low: 26 },
            // ],
          };
        })
      : [
          {
            sun: "29°C",
            H: "29°",
            L: "27°",
            area: props.areaName,
            date: moment().format("dddd Do MMMM"),
            // forecast: [
            //   { day: "Fri", high: 30, low: 27 },
            //   { day: "Sat", high: 29, low: 27 },
            //   { day: "Sun", high: 30, low: 27 },
            //   { day: "Mon", high: 30, low: 27 },
            //   { day: "Tue", high: 30, low: 27 },
            //   { day: "Wed", high: 29, low: 26 },
            // ],
          },
        ];
  return (
    <div className="input-label max-w-xs text-white p-1">
      {forecastData.map((data, index) => {
        return (
          <div
            key={index}
            className="weather-report-img w-[100%] pt-[40px] h-[200px] bg-blue-600 rounded-md p-3 text-center"
          >
            <div className="text-4xl font-bold">{data.sun}</div>
            <div className="text-xs">
              H: {data.H} L: {data.L}
            </div>
            <div className="mt-1 font-semibold">{data.area}</div>
            <div className="text-xs">{data.date}</div>
            {/* <div className="text-xs underline mt-1">See 7-Day Forecast ››</div>
            <div className="grid grid-cols-6 gap-2 mt-1">
              {data.forecast.map((day, i) => (
                <div key={i} className="text-center">
                  <div className="text-xs font-bold">{day.day}</div>
                  <GiRaining className="ml-3 mb-1" />
                  <div className="text-xs">+{day.high}°</div>
                  <div className="text-xs">+{day.low}°</div>
                </div>
              ))}
            </div> */}
          </div>
        );
      })}
      {/* <div className="text-sm font-semibold uppercase mb-2">Weather</div> */}
    </div>
  );
};

WeatherReport.propTypes = {
  areaName: PropTypes.any,
  areaData: PropTypes.any,
};

export default WeatherReport;
